import Model  from "./base/model";

class Audit extends Model{
  resourceName() {
    return "audits";
  }

  fields() {
    return {
      id: "",
      user_name: "",
      user_email: "",
      created_at: "",
      event: "",
      old_values: "",
      new_values: "",
      auditable_type: "",
    }
  }

  async getOrderAudits(id) {
    return this.request(
      this.resourceName() + "/order/" + id,
      "GET",
      {}
    )
  }
}

export default new Audit();

